import './SendoutSessionListTableComponent.scss';
import React from 'react';
import {ITableColumn} from "../../../shared/models/table.model";
import {ISendoutSession} from "../../../shared/models/sendout-session.model";
import {Link} from "react-router-dom";
import {CommonService} from "../../../shared/services";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import TooltipComponent from "../../../shared/components/tooltip/tooltipComponent";
import {APIConfig} from "../../../constants";
import TableWrapperV2Component
    from "../../../shared/components/table-components/table-wrapper-v2/TableWrapperV2Component";
import commonService from "../../../shared/services/common.service";
import {ITestOrder} from "../../../shared/models/testOrder.model";

interface SendoutSessionListTableComponentProps {
    filterData: {};
}

const SendoutSessionListTableComponent = (props: SendoutSessionListTableComponentProps) => {

        const {filterData} = props;

        const columns: ITableColumn[] = [
            {id: 'id', label: 'Session ID', isDefaultColumn: true, fixed: "left", align: "center", width: "120"},
            {
                id: 'lab', label: 'Sendout Lab', isDefaultColumn: true,
                content: (item: ISendoutSession) => (
                    <>
                        {
                            commonService.capitalizeFirstLetterOfEachWord(item?.labDetails?.name)
                        }
                    </>
                )
            },
            {
                id: 'sendout time stamp', label: 'Sendout Date &  Time', isDefaultColumn: true, align: "center",
                content: (item: ISendoutSession) => (
                    <>
                        {
                            item?.createdAt ?
                                <>
                                    {commonService.formatDate(item?.createdAt)}
                                    &nbsp;|&nbsp;
                                    {commonService.formatTime(item?.createdAt)} <br/>
                                </> : <> - </>
                        }
                    </>
                )
            },
            {id: 'sampleCount', label: 'Sample Count', isDefaultColumn: true, align: "center"},
            {
                id: 'tests', label: 'Ordered Tests', align: 'center',
                isDefaultColumn: true,
                content: (item: ITestOrder) => {
                    const tests = item?.testDetails?.map((test:any) => {
                        return {title: test?.code};
                    });
                    return <>
                        {
                            tests?.length > 0 ?
                                <>
                                    {
                                        tests?.map((test:any, index:number) => CommonService.capitalize(test.title)).join(', ').length > 10 ?
                                            <TooltipComponent
                                                tooltip={
                                                    <div className={'pdd-right-15 pdd-top-5 pdd-bottom-5'}>
                                                        {tests?.map((test:any) => {
                                                                return <>{CommonService.capitalize(test.title)}<br/></>;
                                                            }
                                                        )}
                                                    </div>}
                                                arrow={true}>
                                                <div className={'ellipses-for-table-data-tests'}>
                                                    {tests?.map((test:any) => CommonService.capitalize(test.title)).join(', ')}
                                                </div>
                                            </TooltipComponent> :
                                            <>
                                                {tests?.map((test:any) => CommonService.capitalize(test.title)).join(', ')}
                                            </>
                                    }
                                </> :
                                <> - </>
                        }
                    </>
                }
            },
            {
                id: 'addedBy', label: 'Added by', isDefaultColumn: true, align: "center",
                content: (item: ISendoutSession) => (
                    <>
                        {
                            item.createdByDetails ? <div>
                                    { commonService.capitalizeFirstLetterOfEachWord(item?.createdByDetails?.firstName)} { commonService.capitalizeFirstLetterOfEachWord(item?.createdByDetails?.lastName)} </div>
                                : <> - </>
                        }
                    </>
                )
            },
            {
                id: 'actions',
                label: '',
                align: "center",
                fixed: "right",
                width: "100",
                isDefaultColumn: true,
                hideInColumnPreferences: true,
                content: (item: ISendoutSession) => (
                    <>
                        <div className="table-actions" id={`view_send_out_session_` + item.id}>
                            <TooltipComponent tooltip={"View Session details"} placement={"top"}>
                                <Link to={CommonService._routeConfig.SendoutSessionDetailsRoute(item.id)}>
                                    <div className="table-action">
                                        <ChevronRightIcon/>
                                    </div>
                                </Link>
                            </TooltipComponent>
                        </div>
                    </>
                )
            }
        ];

        return (
            <>
                <div className="table-list-container">
                    <TableWrapperV2Component
                        isPaginated={true}
                        columns={columns}
                        url={APIConfig.GET_SEND_OUTS_SESSION_LIST.URL}
                        method={APIConfig.GET_SEND_OUTS_SESSION_LIST.METHOD}
                        extraPayload={filterData}
                        isColumnFilterVisible={true}
                    />
                </div>
            </>
        )

    }

;

export default SendoutSessionListTableComponent;
